<template>
    <div>
        <div class="is-pulled-right" style="display:none">
            <div class="button " :class="{'is-success' : include_archived == 1}" @click="toggleIncludeArchived">Include Archived</div>
        </div>
        
        
        

        <p class="heading mb-1"><strong>Grades</strong></p>
        <div class="buttons mb-3">
            <div class="button is-small" v-for="(grade, key) in grades.filter(g => g.doctor != 1)" :disabled="working==true" :id="grade.id" :key="key" :class="{ 'is-success': selected_grades.includes(grade.id) }" @click="toggleButton(grade.id)">{{ grade.name }}</div>
        </div>

        <p class="heading mb-1"><strong>Doctor Grades</strong></p>
        <div class="buttons mb-3">
            <div class="button is-small" v-for="(grade, key) in grades.filter(g => g.doctor == 1)" :disabled="working==true" :id="grade.id" :key="key" :class="{ 'is-success': selected_grades.includes(grade.id) }" @click="toggleButton(grade.id)">{{ grade.name }}</div>
        </div>

        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false  && members.length == 0">
            No members can be found matching your search criteria
        </div>

        <h4 class="title is-size-4">Cleared Members ({{ this.members.length}})</h4>

        <table class="table is-fullwidth is-hoverable is-size-7" v-if="loading == false && this.members.length > 0">
            <thead>
                <tr>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Grade</th>
                    <th width="80">First Worked In Trust</th>
                    <th width="80">First Shift In Balmoral</th>
                    <th>Telephone</th>
                    <th>Email</th>
                    <th>DOB</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.members" :key="row.id" :class="{'has-background-danger-dark' : row.blocked==1, 'has-text-white' : row.blocked==1, 'has-background-warning' : row.archived==1}">
                    
                    <td><router-link :to="'/members/' + row.id" target="_blank">{{ row.forename }}</router-link></td>
                    <td><router-link :to="'/members/' + row.id" target="_blank">{{ row.surname}}</router-link></td>
                    <td><MemberGradeTags :member="row"/></td>
                    <td><input type="date" v-model="row.first_worked_in_trust" class="input is-small" disabled/></td>
                    <td><input type="date" v-model="row.first_worked_in_balmoral" class="input is-small" disabled/></td>
                    <td>{{ row.mobile }}</td>
                    <td>{{ row.email }}</td>
                    <td>{{ row.date_of_birth_formatted }}</td>
                    
                </tr>
                
                
            </tbody>
            
        </table>

        <table id="memberstable" style="display:none">
            <thead>
                <tr>
                    <th>Member_ID</th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Email</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.members" :key="row.id">
                    <td>{{  row.id }}</td>
                    <td>{{ row.forename }}</td>
                    <td>{{ row.surname }}</td>
                    <td>{{ row.email }}</td>
                    
                </tr>
                </tbody>
        </table>

        <div v-if="loading == false && this.members.length > 0" class="mb-6">
            <h4 class="title is-size-4">Mail Merge Export</h4>
            
            <button class="button is-success" @click="exportXLS()">Export to Excel</button>
        </div>

        <div v-if="loading == false && this.members.length > 0">
            <h4 class="title is-size-4">Email Addresses</h4>
            <p>You  can use this to copy and paste into Outlook to send a manual email. <strong class="has-text-danger">Please be really careful to copy this to the BCC field ONLY.</strong></p>
        
            <p class="mt-4">{{ combinedEmails }}</p>
        </div>

       
    </div>
</template>

<script>
import * as XLSX from 'xlsx'

//import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'MembersByGrade',
        mixins: [MemberMixin],
        components: {
            MemberGradeTags
        },
        data: function () {
            return {
                member_search: '',
                   members: [],
                   loading: false,
                   searchPerformed: false,
                   showModal: false,
                   order_by: 'surname ASC, forename ASC',
                   accessToken: '',
                   include_archived: 0,
                   grades: [],
                   selected_grades: [0],
                   working:false
            }
        },
        methods: {
            exportXLS() {
		
                var wb = XLSX.utils.table_to_book(document.getElementById('memberstable'), {sheet:"Sheet JS"});
                XLSX.writeFile(wb, 'Members_Mail_Merge.xlsx')

            },
            toggleButton(buttonId) {
                this.working = true;
                const index = this.selected_grades.indexOf(buttonId);
                if (index === -1) {
                    // Button not selected, add it to the selectedButtons array
                    this.selected_grades.push(buttonId);
                } else {
                    // Button already selected, remove it from the selectedButtons array
                    this.selected_grades.splice(index, 1);
                }
                this.getMembers(this.order_by, '', this.selected_grades, 0, 1);
            },
            toggleIncludeArchived()
            {
                if(this.include_archived == 1)
                {
                    this.include_archived = 0
                }
                else{
                    this.include_archived = 1
                }
                this.getMembers(this.order_by, this.include_archived, "", 0, 1);
            },
            resetForm()
            {
                this.member_search = '';
                localStorage.member_search = '';
                this.searchPerformed = false
                this.members = [];

                this.$refs.member_search.focus();
            },
            searchMembers()
            {
                //localStorage.member_search = this.member_search;
                //this.getMembers(this.order_by, this.include_archived);
            }
            
        },
        created() {
            this.getAccessToken()
                .then(() => { 
                    this.getMembers(this.order_by, '', this.selected_grades, 0, 1);
                    this.getGrades();
                });
        
        },
        mounted() {
            
        },
        computed: {
            combinedEmails() {
            return this.members.map(member => member.email).join('; ');
            }
        }
       
    }
</script>